let lastScrollTop = 0;
let header = document.querySelector('.shopify-section-header ');
let ticking = false;

window.addEventListener('scroll', function() {
    if (!ticking) {
        window.requestAnimationFrame(function() {
            let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            
            // Scrolling DOWN
            if (scrollTop > lastScrollTop && scrollTop > 100) {
                // Add fixed class with smooth transition
                header.classList.add('fixed');
                header.style.transform = 'translateY(0)';
                
            // Scrolling UP
            } else if (scrollTop < lastScrollTop && scrollTop <= 100) {
                // Remove fixed class smoothly
                header.classList.remove('fixed');
                header.style.transition = 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)';
                header.style.transform = 'translateY(0)';
            }
            
            lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
            ticking = false;
        });
        ticking = true;
    }
}, {passive: true});
